import React from 'react'

const SvgCoverLetter = props => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="currentColor" {...props}>
    <path d="M28.127 16.661L20 11.576l-8.127 5.085A1.792 1.792 0 0011 18.2v9c0 .99.81 1.8 1.8 1.8h14.4c.99 0 1.8-.81 1.8-1.8v-9c0-.657-.351-1.224-.873-1.539zM27.2 27.2H12.8V20l7.2 4.5 7.2-4.5v7.2zM20 22.7l-7.2-4.5 7.2-4.5 7.2 4.5-7.2 4.5z" />
  </svg>
)

export default SvgCoverLetter
